var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChevronDown = function SvgIconsChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.78 9.683c.28-.244.732-.244 1.01 0 .256.224.278.575.065.82l-.064.064-4.286 3.75c-.256.224-.657.242-.937.056l-.073-.056-4.286-3.75c-.279-.244-.279-.64 0-.884.256-.224.657-.242.937-.056l.073.056L12 12.991l3.78-3.308z"
  })));
};
export default SvgIconsChevronDown;